import React from 'react';
import { COLORS } from './colors';
import { Box, decomposeColor, SxProps, Theme } from '@mui/system';
import { Typography } from '@mui/material';

type NotificationProps = {
  component?: React.ElementType;
  theme: 'success' | 'warning' | 'danger' | 'info';
  title?: string;
  description?: JSX.Element;
  extraSx?: SxProps<Theme>;
};

const Notification: React.FC<NotificationProps> = ({ component = 'div', theme, title, description, extraSx }) => {
  let color;

  switch (theme) {
    case 'success':
      color = COLORS.success[100];
      break;
    case 'warning':
      color = COLORS.warning[100];
      break;
    case 'danger':
      color = COLORS.alert[100];
      break;
    case 'info':
    default:
      color = COLORS.brand[100];
      break;
  }

  return (
    <Box
      component={component}
      sx={{
        listStyleType: 'none',
        display: 'flex',
        flexDirection: 'column',
        pl: 2,
        pr: 4,
        py: 1,
        backgroundColor: `rgba(${decomposeColor(color).values},.1)`,
        borderLeft: `4px solid ${color}`,
        ...extraSx,
      }}
    >
      {title && (
        <Typography variant="body1" component="p" sx={{ fontWeight: 700, mb: 0.5 }}>
          {title}
        </Typography>
      )}
      <Typography variant="body2" component="div">
        {description}
      </Typography>
    </Box>
  );
};

export default Notification;
